import { render, staticRenderFns } from "./chance-collect.vue?vue&type=template&id=6c9932bd&scoped=true&"
import script from "./chance-collect.vue?vue&type=script&lang=js&"
export * from "./chance-collect.vue?vue&type=script&lang=js&"
import style0 from "./chance-collect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./chance-collect.vue?vue&type=style&index=1&id=6c9932bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9932bd",
  null
  
)

export default component.exports